/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 */

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
